import {StaticImage, StaticPath} from './common';


/**课程概述数据*/
export const HomeOver = {
  branner: [
    `${StaticPath.OSS_PATH}${StaticImage.HOME_BRANNER_1}`,
    `${StaticPath.OSS_PATH}${StaticImage.HOME_BRANNER_2}`,
    `${StaticPath.OSS_PATH}${StaticImage.HOME_BRANNER_3}`,
    `${StaticPath.OSS_PATH}${StaticImage.HOME_BRANNER_4}`,
    `${StaticPath.OSS_PATH}${StaticImage.HOME_BRANNER_5}`


  ],
  why: {
    h1: '为什么选择此刻芭蕾',
    data: [
      {
        img: StaticPath.OSS_PATH.concat('/h5/home/target/icon_2x.jpg'),
        title: '专注成⼈',
        text: '专注零基础成⼈芭蕾课程，更懂零基础成年⼈的身体素质',
        alt: ''
      },
      {
        img: StaticPath.OSS_PATH.concat('/h5/home/target/icon-2_2x.jpg'),
        title: '专业师资',
        text: '统⼀教材，统⼀进度，专业芭蕾教师',
        alt: ''
      },
      {
        img: StaticPath.OSS_PATH.concat('/h5/home/target/icon-4_2x.jpg'),
        title: '多店直营',
        text: '8 家直营店，15 个精装课室，400+可选课时每周，更容易在你合适的时间，选到合适的课程',
        alt: ''
      },
      {
        img: StaticPath.OSS_PATH.concat('/h5/home/target/icon-1_2x.jpg'),
        title: '小班教学',
        text: '此刻芭蕾根据各直营分店的教室大小不同开设6～15人的小班教学课程，确保每一位学员都能获得充分的关注',
        alt: ''
      },
      {
        img: StaticPath.OSS_PATH.concat('/h5/home/target/icon-3_2x.jpg'),
        title: '特色资源',
        text: '此刻芭蕾定期举办格式芭蕾主题沙龙，并邀请国内外芭蕾行业大咖前往开设大师课，为同学们提供多元化的芭蕾体验',
        alt: ''
      },
      {
        img: StaticPath.OSS_PATH.concat('/h5/home/target/icon-5_2x.jpg'),
        title: '更大舞台',
        text: '此刻芭蕾每年都在广州标志性的各大剧院举办大型的主题汇演，由此刻芭蕾老师编创与排练，由同学们参演完成',
        alt: ''
      }
    ]
  },
  target: {
    h1: '芭蕾的好处',
    data: [
      {
        img: 'https://www.jinpaocun.com/templets/1234/images/xxmb_1@2x.jpg',
        title: '减压',
        alt: '',
        smSpan: 24,
        lgSpan: 6,
        text: '学习过程注意⼒⾼度集中\n聚焦控制身体的每⼀块肌⾁\n⼤量⾼强度职业⼈⼠选择在此刻芭蕾\n每周固定的芭蕾课程作为⾃⼰的减压⽅式'
      },
      {
        img: 'https://www.jinpaocun.com/templets/1234/images/xxmb_2@2x.jpg',
        title: '改善体态',
        alt: '',
        smSpan: 12,
        lgSpan: 6,
        text: '没有其他运动/舞蹈能像芭蕾⼀样\n对体态进⾏如此有效的矫正和提升\n“天鹅颈”、“天鹅臂”、“天鹅背”\n“⼤⻓腿”、 “优雅⽓质”、“柔韧度”\n这些都属于芭蕾练习者的形象标签'
      },
      {
        img: 'https://www.jinpaocun.com/templets/1234/images/xxmb_3@2x.jpg',
        title: '快乐',
        alt: '',
        smSpan: 12,
        lgSpan: 6,
        text: '芭蕾的快乐\n来⾃于感受到⾃⼰对身体的控制\n看到镜⼦⾥的⾃⼰原来可以这么美'
      },
      {
        img: 'https://www.jinpaocun.com/templets/1234/images/xxmb_4@2x.jpg',
        title: '自主学习能力',
        alt: '',
        smSpan: 24,
        lgSpan: 6,
        text: '培养学生自主自发学习能力\n养成终身学习进步的习惯\n学会自主探索新事物的能力\n快速适应日新月异的社会变化'
      },
    ]
  },
  brand: {
    h1: '品牌',
    h2: '致⼒于帮助更多⼈从零基础开始接触到芭蕾的美好',
    h3: '让更多⼈通过芭蕾收获⽣活的启发',
    text: '⽤芭蕾点亮更多笑容'
  },
  introduction: {
    h1: '简介',
    data: {
      text: '此刻芭蕾BALLETME 于2015年 由北京舞蹈学院芭蕾硕士王蓉在广州创立，\n专注于成人零基础的芭蕾课程，目前此刻芭蕾在广州地区直营9家门店，\n每年服务超过数十万人次的成人芭蕾爱好者到店。在广州，每10个正在学习芭蕾的成年芭蕾爱好者，7个在此刻芭蕾。',
      maxim: 'For Every Smile Inspired by Ballet. \n 为了每⼀个被芭蕾点亮的笑容'
    }
  },
  course: {
    h1: '课程',
    title:'浸泡村国际英语专注英语听说能力培训，多年专业教学，为学员提供高品质培训课程，让您在1-2年内讲好一口流利英语。',
    data: [
      {
        id: 'ballet',
        name: '芭蕾课程',
        alt: '芭蕾课程',
        img: StaticPath.OSS_PATH.concat('/h5/home/course/course.png?x-oss-process=image/resize,m_lfit,h_210,w_250'),
        msg: '课程介绍'
      },
      {
        id: 'auxiliary',
        name: '辅助课程',
        alt: '芭蕾辅助',
        img: StaticPath.OSS_PATH.concat('/h5/home/course/course.png?x-oss-process=image/resize,m_lfit,h_210,w_250'),
        msg: '课程介绍'
      },
      {
        id: 'skill',
        name: '技巧课程',
        alt: '芭蕾技巧',
        img: StaticPath.OSS_PATH.concat('/h5/home/course/course.png?x-oss-process=image/resize,m_lfit,h_210,w_250'),
        msg: '课程介绍'
      },
      {
        id: 'toe',
        name: '足尖课程',
        alt: '芭蕾足尖',
        img: StaticPath.OSS_PATH.concat('/h5/home/course/course.png?x-oss-process=image/resize,m_lfit,h_210,w_250'),
        msg: '课程介绍'
      },
      {
        id: 'plot',
        name: '剧目课程',
        alt: '芭蕾剧目',
        img: StaticPath.OSS_PATH.concat('/h5/home/course/course.png?x-oss-process=image/resize,m_lfit,h_210,w_250'),
        msg: '课程介绍'
      },
      {
        id: 'private',
        name: '私教课程',
        alt: '芭蕾私教',
        img: StaticPath.OSS_PATH.concat('/h5/home/course/course.png?x-oss-process=image/resize,m_lfit,h_210,w_250'),
        msg: '课程介绍'
      },
      {
        id: 'salon',
        name: '主题课程',
        alt: '芭蕾沙龙',
        img: StaticPath.OSS_PATH.concat('/h5/home/course/course.png?x-oss-process=image/resize,m_lfit,h_210,w_250'),
        msg: '课程介绍'
      },
      {
        id: 'assemble',
        name: '集训课程',
        alt: '芭蕾集训',
        img: StaticPath.OSS_PATH.concat('/h5/home/course/course.png?x-oss-process=image/resize,m_lfit,h_210,w_250'),
        msg: '课程介绍'
      }
    ]
  }
};


/**门店数据*/
export const HomeShop = {
  distribution: {
    h1: '校区分布',
    data: []
  },
  decoration: {
    h1: '校区环境',
    images: [
      {class: 'decoration-img', url: 'https://www.jinpaocun.com/templets/1234/images/pic-4@2x.jpg', alt: ''},
      {class: 'decoration-img', url: 'https://www.jinpaocun.com/templets/1234/images/pic-4@2x.jpg', alt: ''}
    ]
  }
};

/**关于我们*/
export const AboutOver = {
  history: {
    h1: '发展历程',
    data: [
      {time: '2015', text: '9月 成立 芭蕾教师: 2人 (祥龙店)'},
      {time: '2017', text: '4月 教学体系'},
      {time: '2018', text: '3月 芭蕾教师: 10人 (东站店/华师店/丽景店)'},
      {time: '2018', text: '4月 首次汇演《天鹅湖》，演员96人'},
      {time: '2019', text: '4月 小程序1.0上线 芭蕾教师:22人  (中盈店/289店/淘金店/客村店/东站店/华师店/三银店)'},
      {time: '2019', text: '5月 大型汇演《至生活以拥抱》，演员149人'},
      {time: '2019', text: '9月 芭蕾教师: 28人 (长隆店/中盈店/289店/淘金店/客村店/东站店/华师店/三银店)'},
      {time: '2020', text: '2月 线上课程'},
      {time: '2020', text: '4月 芭蕾教师: 32人 (越秀店/长隆店/中盈店/289店/淘金店/客村店/东站店/华师店/三银店)'},
      {time: '2020', text: '5月 小程序2.0'},
      {time: '2020', text: '精彩继续'},

    ]
  }
};

